import React from 'react';
import { Helmet } from 'react-helmet';
import YandexMap from '../components/YandexMap';
import '../styles/Contacts.css'

const Contacts = () => {
  return (
    <div className="contacts-page">
      <Helmet>
        <title>Контакты - ReserveCar</title>
        <meta name="description" content="Свяжитесь с нами для аренды автомобиля по низкой цене в Калининграде." />
      </Helmet>
      <h1>Контакты</h1>
      <div className="contact-info">
        <p>Телефон: +7 (962) 269-99-94</p>
        <p>Email: booking@reservecar.ru</p>
        <p>Адрес: Калининград, ул. Калининградская 35А, корп. 1</p>
      </div>

      <h2>Наш офис на карте:</h2>
      <div className="map-container">
        <YandexMap />
      </div>
    </div>
  );
};

export default Contacts;